import { FETCH_MOTOR_ACTION, RESET_MOTOR_ACTION } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const motorLogViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MOTOR_ACTION:
      return { data: action.payload };
    case RESET_MOTOR_ACTION:
      return initialState;
    default:
      return state;
  }
};

export default motorLogViewReducer;
